import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchVehicleType,
  selectVehicleType,
  setDataSuccess
} from 'src/features/staticDataSlice';
import VehicleTypeCreateModal from 'src/pages/VehichleType/VehicleTypeCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function VehicleTypeList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [vehicleTypeCreatePermission, setVehicleTypeCreatePermission] = useState(false);

  const vehicleTypeData = useSelector(selectVehicleType);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setVehicleTypeCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('vehicleType', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchVehicleType(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'vehicleType', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation if required

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-vehicleType" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-vehicleType"
          id="select-vehicleType"
          value={tableListDatas[index]?.vehicleType || ''}
          onChange={(event) => {
            handleChange('vehicleType', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {vehicleTypeData?.map((vehicle) => (
            <MenuItem key={vehicle?.vehichleType} value={vehicle?.vehichleType}>
              {vehicle?.vehichleType}
            </MenuItem>
          ))}
          <Tooltip
            title={
              vehicleTypeCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Vehicle Type
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (vehicleTypeCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: vehicleTypeCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <VehicleTypeCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default VehicleTypeList;
